<template>
  <div class="layer waitingcallAddInfo">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle">{{locale.manage_registration_info}}</h2>
      
      <div class="fieldList mb30">
        <div v-for="(field, index) in fields" :key="index" class="fieldItem mb15">
          <div class="translation">
            <SetLanguageValue :locale="locale" :langValue="field.label" :textarea="true" style="flex: 1;"/>
          <button type="button" class="btnDelete" @click="removeField(index)">
            <span class="blind">delete</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
          </div>
        </div>
        
        <button type="button" class="btnAddField" @click="addField">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </button>
      </div>

      <div class="btnsWrapper">
        <button type="button" class="btn btnWhite half" @click="close">{{locale.cancel}}</button>
        <button type="button" class="btn btnPrimary half" @click="save">{{locale.save}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import LangValue from '@/components/Util/LangValue.vue'
import SetLanguageValue from '@/components/Util/SetLanguageValue.vue'
import LANG from '@/common/lang'
import UTIL from '@/common/util'

export default {
  name: 'WaitingcallAddInfo',
  props: [
    'locale',
    'lang',
    'initialFields'
  ],
  components: {
    LangValue,
    SetLanguageValue
  },
  computed: {
    isInvalid () {
      // 사용가능한 언어 코드 가져오기
      const langSetting = this.$store.getters['setting/getData']
      let usableCodes = langSetting && langSetting.lang && langSetting.lang.info
        ? langSetting.lang.info.filter(x => x.u).map(x => x.c)
        : []
      usableCodes = [...new Set(usableCodes)] // 중복 코드 제거
      
      if (this.fields.length === 0) return false

      // 사용가능한 언어 코드 중 하나라도 비어있으면 유효하지 않은 필드로 간주
      return this.fields.some(field => {
        return usableCodes.some(code => {
          const val = field.label[code]
          return !val || val.trim() === ''
        })
      })
    },
    isDuplicateName() {
      const langSetting = this.$store.getters['setting/getData']
      // 모든 언어 코드를 가져온 후 중복 제거 (자기 자신 중복 인식 방지 및 전체 언어 검사)
      const allCodes = langSetting && langSetting.lang && langSetting.lang.info
        ? langSetting.lang.info.map(x => x.c)
        : []
      const uniqueCodes = [...new Set(allCodes)]

      const namesByLang = {}
      uniqueCodes.forEach(code => {
        namesByLang[code] = new Set()
        
        // 현재 서비스언어 설정에 해당하는 기본 등록정보 명칭 추가
        if (code === this.$store.state.service.locale.default) {
          if (this.locale.tel) namesByLang[code].add(this.locale.tel.trim())
          if (this.locale.email) namesByLang[code].add(this.locale.email.trim())
        }
      })

      for (const field of this.fields) {
        for (const code of uniqueCodes) {
          const name = field.label[code] ? String(field.label[code]).trim() : ''
          
          if (name !== '') {
            if (namesByLang[code].has(name)) {
              return name // 중복명 반환
            }
            namesByLang[code].add(name)
          }
        }
      }
      return false
    },
  },
  data () {
    return {
      fields: this._.cloneDeep(this.initialFields || []),
      langValueLayer: false,
      langValue: {},
      currentFieldIndex: null
    }
  },
  methods: {
    addField () {
      this.fields.push({
        id: `custom_${Date.now()}`,
        label: LANG.valueObj('')
      })
    },
    removeField (index) {
      this.fields.splice(index, 1)
    },
    setDefaultVal (index) {
      const defaultLang = this.lang.default
      const field = this.fields[index]
      const fillLangs = UTIL.fillLangs(field.label, field.label[defaultLang])
      field.label = fillLangs
    },
    onLangValueOpen (index) {
      this.currentFieldIndex = index
      this.langValue = this.fields[index].label
      this.langValueLayer = true
    },
    onLangValueClose () {
      const index = this.currentFieldIndex
      if (index !== null) {
        this.fields[index].label = this.langValue
      }
      this.langValueLayer = false
      this.langValue = {}
      this.currentFieldIndex = null
    },
    save () {
      if(this.isInvalid){
        alert(this.locale.please_enter_all_languages_in_use)
        return
      }

      const duplicateName = this.isDuplicateName
      if (duplicateName) {
        alert(`${this.locale.duplicate_registration_names_cannot_be_used}::[${duplicateName}]`);
        return
      }

      if(window.confirm(this.locale.confirm_save)){
        this.$emit('save', this.fields)
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.waitingcallAddInfo {
  .fieldList {
    max-height: 400px;
    overflow-y: auto;
  }
  .fieldItem {
    .translation {
      display: flex;
      align-items: center;
      .input {
        flex: 1;
      }
      .btnTranslation {
        margin-left: -40px;
        z-index: 1;
      }
      .btnDelete {
        position: relative;
        margin-left: 15px;
        width: 24px;
        height: 24px;
        color: #666;
        &:hover {
          color: #000;
        }
      }
    }
  }
  .btnAddField {
    width: 100%;
    height: 60px;
    border: 2px dashed #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ddd;
    background: none;
    border-radius: 4px;
    transition: all 0.2s;
    &:hover {
      border-color: #999;
      color: #999;
    }
  }
  .btnsWrapper {
    display: flex;
    gap: 10px;
    .half {
      flex: 1;
    }
  }
  .translation {
    display: flex;
  }
}
</style>
